import React,{ useEffect, useState } from 'react';
import {Page,InfiniteLoader } from 'react-weui';
import { Toast } from 'antd-mobile';

import { getLastUpdate,getLikeList,getProgramVideos } from '@/services/program';
import styles from './styles.scss';
import Empty from '@/components/empty';
import { history } from 'umi';


export default (props) => {
  const programId = props.location.state.programId;
  const type = props.location.state.type;
  const areaCode =  props.location.state.areaCode;

  const [dataList, setDataList] = useState([]);
  const[pageNo,setPageNo] = useState(1);
  const [totalCount, setTotalCount] = useState(0); // 新增总条数



  useEffect(()=>{
    document.title = props.location.state.title;
    
   getList(1);

  },[]);

  function getList(page, resolve, finish) {
    if (type == 'lastUpdate') {
      lastUpdateList(page,resolve,finish);
    }else if (type == 'like') {
      likeList(page,resolve,finish);
    } else {
      programVideos(page,resolve,finish);
    }
  }



  function likeList(page, resolve, finish) {
    getLikeList({pageNo: page,pageSize:20,areaCode:areaCode}).then(res => {
      console.log(res);
      if (res.code == 200) {
        setTotalCount(res.data.count || 0); // 更新总条数
        if (page == 1) {
          setDataList(res.data.list);
        } else {
          setDataList(prev => prev.concat(res.data.list));
        }
        setPageNo(page);
        resolve && resolve();
        // 不再用list.length判断finish，由onLoadMore统一判断
      } else {
        Toast.fail(res.message,1);
        resolve && resolve();
      }
    }).catch(e =>{
      Toast.fail('请求失败，请重试',1);
      resolve && resolve();
    });
  }

  function lastUpdateList(page, resolve, finish) {
    getLastUpdate({pageNo: page,pageSize:20,areaCode:areaCode}).then(res => {
      console.log(res);
      if (res.code == 200) {
        setTotalCount(res.data.count || 0); // 更新总条数
        if (page == 1) {
          setDataList(res.data.list);
        } else {
          setDataList(prev => prev.concat(res.data.list));
        }
        setPageNo(page);
        resolve && resolve();
        // 不再用list.length判断finish，由onLoadMore统一判断
      } else {
        Toast.fail(res.message,1);
        resolve && resolve();
      }
    }).catch(e =>{
      Toast.fail('请求失败，请重试',1);
      resolve && resolve();
    });
  }

  function programVideos(page, resolve, finish) {
    getProgramVideos({pageNo: page,pageSize:20,columnId:programId}).then(res => {
      console.log(res);
      if (res.code == 200) {
        setTotalCount(res.data.count || 0); // 更新总条数
        if (page == 1) {
          setDataList(res.data.list);
        } else {
          setDataList(prev => prev.concat(res.data.list));
        }
        setPageNo(page);
        resolve && resolve();
        // 不再用list.length判断finish，由onLoadMore统一判断
      } else {
        Toast.fail(res.message,1);
        resolve && resolve();
      }
    }).catch(e =>{
      Toast.fail('请求失败，请重试',1);
      resolve && resolve();
    });
  }





  return (
    <Page transition={true} infiniteLoader={true} ptr={false}
          onLoadMore={ (resolve, finish) => {
            if (dataList.length >= totalCount && totalCount !== 0) {
              finish();
              return;
            }
            getList(pageNo+1, resolve,finish);
          }}
    >

      {dataList.length ? dataList.map((item,i) =>(
        <div key={''+i} className={styles.vertical_item} onClick={()=>{
          history.push('/program/programDetail?programId=' + item.columnId + '&videoId=' + item.id + '&title=' + item.column.name);

        }}>
          <img src={item.image}/>

          <div>
            <label className={styles.vertical_title}>{item.videoName}</label>
            <label className={styles.vertical_sub}>{item.dateName}</label>
          </div>
        </div>
      )) : <Empty text={'暂无数据'}/>}
      {dataList.length >= totalCount && totalCount !== 0 && (
        <div style={{ textAlign: 'center', color: '#888', padding: '12px 0' }}>
          没有更多数据了
        </div>
      )}


    </Page>
  )
}


